<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.6"
    height="13.4"
    viewBox="0 0 17.6 13.4"
  >
    <g transform="translate(-3.4 -5.6)">
      <path class="a" d="M9,16.2,4.8,12,3.4,13.4,9,19,21,7,19.6,5.6Z" />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'ArrowTickIcon',
};
</script>
